import _ from "lodash";

function convRGBToInt(s) {
  var r = 0;
  if (s) {
    var h = parseInt("0xFF" + s + "L");
    r = -1 & h;
  }
  return r;
}

const convIntToRGB = (c) => {
  var rgb = "ffffff";
  // convert the signed int to an unsigned int
  c = c >>> 0;
  // convert to HEX and get the last 6 chars for the RGB value
  if (c) rgb = c.toString(16).substr(-6);
  return rgb;
};

function getTextColorBasedOnRGB(rgb) {
  if (typeof rgb === "string") {
    //these methods borrowed from JSColor
    var r = parseInt(rgb.substr(0, 2), 16) / 255;
    var g = parseInt(rgb.substr(2, 2), 16) / 255;
    var b = parseInt(rgb.substr(4, 2), 16) / 255;
    return 0.213 * r + 0.715 * g + 0.072 * b < 0.5 ? "FFFFFF" : "000000";
  }
  return "FFFFFF"; //fallback
}

let defaultCourseColors = {
  Course1: "947550",
  Course2: "002cff",
  Course3: "007a77",
  Course4: "a300db",
  Default: "666666",
};

let getDefaultCourseColors = function (crsNum) {
  switch (crsNum) {
    case 1:
      return defaultCourseColors.Course1;
    case 2:
      return defaultCourseColors.Course2;
    case 3:
      return defaultCourseColors.Course3;
    case 4:
      return defaultCourseColors.Course4;
    default:
      return defaultCourseColors.Default;
  }
};

let rgb = function (siteSettingData, courseNumber) {
  if (siteSettingData && Object.keys(siteSettingData).length !== 0) {
    var tempCrs = _.find(siteSettingData.Courses, { Number: courseNumber });
    if (courseNumber) {
      return !_.isNull(tempCrs?.ColorRGB) && !_.isUndefined(tempCrs?.ColorRGB)
        ? convIntToRGB(tempCrs?.ColorRGB)
        : getDefaultCourseColors(courseNumber);
    }
    return getDefaultCourseColors(courseNumber);
  }
  return "#947550";
};

let txtColor = function (rgb) {
  return getTextColorBasedOnRGB(rgb);
};

let CourseBGColor = function (siteSettingData, courseNumber) {
  return "#" + rgb(siteSettingData, courseNumber);
};

let CourseTxtColor = function (siteSettingData, courseNumber) {
  return "#" + txtColor(rgb(siteSettingData, courseNumber));
};

let invertHexColor = (hexnum) => {
  if (hexnum.length !== 6) {
    alert("Hex color must be six hex numbers in length.");
    return false;
  }

  hexnum = hexnum.toUpperCase();
  var splitnum = hexnum.split("");
  var resultnum = "";
  var simplenum = "FEDCBA9876".split("");
  var complexnum = [];
  complexnum.A = "5";
  complexnum.B = "4";
  complexnum.C = "3";
  complexnum.D = "2";
  complexnum.E = "1";
  complexnum.F = "0";

  for (var i = 0; i < 6; i++) {
    if (!isNaN(splitnum[i])) {
      resultnum += simplenum[splitnum[i]];
    } else if (complexnum[splitnum[i]]) {
      resultnum += complexnum[splitnum[i]];
    } else {
      alert("Hex colors must only include hex numbers 0-9, and A-F");
      return false;
    }
  }

  return resultnum;
};

function lightOrDark(color) {
  // Variables for red, green, blue values
  var r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return "light";
  } else {
    return "dark";
  }
}

export const mapHelpers = {
  convRGBToInt,
  convIntToRGB,
  getTextColorBasedOnRGB,
  getDefaultCourseColors,
  CourseBGColor,
  CourseTxtColor,
  invertHexColor,
  lightOrDark,
};
